export const publicRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login-page" */'views/LoginPage')
  },
  {
    path: '/redefinir-senha/:token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: 'reset-password-page' */ 'views/ResetPasswordPage')
  },
  {
    path: '/primeiro-acesso/:token',
    name: 'FirstAccessLogin',
    component: () => import(/* webpackChunkName: 'first-access-login-page' */ 'views/ResetPasswordPage')
  },
  {
    path: '/primeiro-acesso/colaborador/:employeeId/token/:token',
    name: 'FirstAccess',
    component: () => import(/* webpackChunkName: 'first-access-page' */ 'views/FirstAccessPage')
  }
]
